import React from "react";
import { compose } from "redux";
import { Grid } from "@material-ui/core";
import { Field } from "redux-form/immutable";

import { required } from "utils/validation.util";
import ColorField from "app/components/ColorField";
import TextField from "app/components/form/TextField";
import { QUALIFICATION_FORM } from "features/planner/planner.constants";

const QualificationForm = ({ handleSubmit }) => {
  return (
    <form onSubmit={handleSubmit} id={QUALIFICATION_FORM.ID}>
      <Grid container>
        <Grid item xs={12}>
          <Field
            autoFocus
            required
            label="Name"
            validate={[required]}
            component={TextField}
            name={QUALIFICATION_FORM.NAME}
          />
        </Grid>
      </Grid>
      <Grid container spacing={2} justifyContent="center">
        <Grid item>
          <Field
            validate={[required]}
            component={ColorField}
            name={QUALIFICATION_FORM.BACKCOLOR}
          />
        </Grid>
      </Grid>
    </form>
  );
};

export default compose()(QualificationForm);
